class Certificate {
  constructor({ url }) {
    this.url = url;
  }
}

export default Certificate;
